import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { triggerSuspendedMerchantIsViewed } from 'core/modules/MerchantExperience/actions';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import RelatedCategoryFeaturedStores from 'core/modules/RelatedCategoryFeaturedStores/RelatedCategoryFeaturedStores';
import CuratedActiveMerchants from 'core/modules/CuratedActiveMerchants/CuratedActiveMerchants';
import MerchantSuspendedActionMessages from '../../MerchantSuspendedActionMessages/MerchantSuspendedActionMessages';
import MerchantPageTitle from '../../MerchantPageTitle/MerchantPageTitle';
import {
  MERCHANT_EXPERIENCE_TYPE_SUSPENDED,
} from '../../../actions/types';

export function MerchantExperienceViewSuspended({ merchant, config, keywords }) {
  const [hasAnyRelatedContentToShow, setHasAnyRelatedContentToShow] = useState(false);
  const { currency } = config;
  const dispatch = useDispatch();

  useEffect(() => {
    const { relatedActiveMerchants } = merchant;
    const hasRelatedActiveMerchantsToShow = relatedActiveMerchants && relatedActiveMerchants.length > 0;
    hasRelatedActiveMerchantsToShow && setHasAnyRelatedContentToShow(true);
    dispatch(triggerSuspendedMerchantIsViewed(merchant));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkIfHasRelatedCategoriesToShow = (hasRelatedCategoriesToShow) => {
    hasRelatedCategoriesToShow && setHasAnyRelatedContentToShow(true);
  };

  return (
    <div
      className="mn_merchantExperienceSuspendedMerchant"
      data-test="merchant-experience-suspended"
      data-suspended-merchant-name={merchant.name}
      data-page-type={MERCHANT_EXPERIENCE_TYPE_SUSPENDED}
    >
      <ContentWrap>
        <MerchantPageTitle merchant={merchant} config={config} isSuspended />
        {
          hasAnyRelatedContentToShow &&
          <h3 className="mn_subHeader" data-test="merchant-experience-suspended-subheader">
            However, you can earn {currency} at great stores like these:
          </h3>
        }
        <CuratedActiveMerchants merchant={merchant} />
        <RelatedCategoryFeaturedStores
          merchant={merchant}
          categoriesLoadedCallback={checkIfHasRelatedCategoriesToShow}
        />
        <MerchantSuspendedActionMessages merchant={merchant} config={config} keywords={keywords} />
      </ContentWrap>
    </div>
  );
}

MerchantExperienceViewSuspended.propTypes = {
  merchant: PropTypes.shape({
    relatedActiveMerchants: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  config: PropTypes.shape({}),
  keywords: PropTypes.string,
};

MerchantExperienceViewSuspended.defaultProps = {
  merchant: {
    relatedActiveMerchants: [],
  },
  config: {},
  keywords: null,
};

export default (props) =>
  <ComponentErrorBoundary><MerchantExperienceViewSuspended {...props} /></ComponentErrorBoundary>;
